module.exports = __webpack_public_path__ + "static/media/home_logo.a854242a.png";